import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { UserRoundCheck, ShieldOff } from "lucide-react";

export default function HandoffToggleWidget() {
  const [settings, setSettings] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = async () => {
    try {
      const r = await api.get("/messaging/admin/qualification-settings");
      setSettings(r.data);
    } catch { /* silent */ }
  };
  useEffect(() => { load(); }, []);

  const toggle = async () => {
    if (!settings) return;
    setSaving(true);
    try {
      const next = { ...settings, human_handoff_enabled: !settings.human_handoff_enabled };
      await api.put("/messaging/admin/qualification-settings", next);
      setSettings(next);
      toast.success(next.human_handoff_enabled ? "Handoff automático ativado" : "Handoff silencioso ativado — LIA completa triagem antes de transferir");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Não foi possível salvar");
    } finally { setSaving(false); }
  };

  if (!settings) return null;
  const on = !!settings.human_handoff_enabled;

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4" data-testid="handoff-toggle-widget">
      <div className="flex items-center gap-2 font-bold text-[#0B2B62] mb-2">
        {on ? <UserRoundCheck className="w-4 h-4 text-emerald-600"/> : <ShieldOff className="w-4 h-4 text-amber-600"/>}
        Handoff quando visitante pede "atendente humano"
      </div>
      <p className="text-xs text-slate-500 mb-3">
        Quando ligado, LIA transfere na hora que o visitante pede um atendente. Quando desligado (<b>silencioso</b>), LIA reconhece o pedido, segue a triagem restante e transfere já com o resumo pronto — evitando o visitante repetir tudo.
      </p>
      <button
        onClick={toggle}
        disabled={saving}
        data-testid="handoff-toggle-btn"
        className={`w-full py-2 rounded-lg text-sm font-semibold transition ${on ? "bg-emerald-100 text-emerald-800 hover:bg-emerald-200" : "bg-amber-100 text-amber-900 hover:bg-amber-200"}`}
      >
        {saving ? "Salvando..." : on ? "Handoff imediato · Clique para deixar silencioso" : "Handoff silencioso · Clique para reativar imediato"}
      </button>
    </div>
  );
}
